"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.softloggedNotificationController = void 0;
const storage_1 = require("../services/storage");
const workers_1 = require("../services/workers");
const notifications_1 = require("../services/notifications");
const common_1 = require("../utils/common");
function softloggedNotificationController({ context, userPq, userRecom, addNotifications, customer, worker, userPo, }) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const userId = context === null || context === void 0 ? void 0 : context.userIdPartyHash;
        const { cachedNotifications, cachedUnreadNotifications } = yield (0, storage_1.getCachedNotifications)({ userId });
        const { outdatedNotis, upToDateNotis } = (0, notifications_1.clusterNotificationTypesByExpiration)(cachedNotifications);
        let unreadNotifications = cachedUnreadNotifications || [];
        let finalNotifications = cachedNotifications || {};
        if (outdatedNotis.includes("commertial")) {
            if (!worker) {
                worker = yield (0, workers_1.spawnWorkerInstance)();
            }
            const commertialRes = yield worker.getNotifications({
                context,
                userPq,
                userRecom,
                customer,
                userPo,
            }, ["commertial"]);
            const cachedCommertial = (cachedNotifications === null || cachedNotifications === void 0 ? void 0 : cachedNotifications["commertial"]) || {};
            const currentCommertial = (_a = commertialRes === null || commertialRes === void 0 ? void 0 : commertialRes.notifications) === null || _a === void 0 ? void 0 : _a.commertial;
            const { notification: commertial, unreadHashList } = (0, notifications_1.normalizeReadNotification)(cachedCommertial, currentCommertial);
            unreadNotifications = (0, common_1.mergeArryUnique)(unreadNotifications, unreadHashList);
            if (commertial) {
                finalNotifications.commertial = commertial;
            }
        }
        yield (0, storage_1.setCachedNotifications)({
            userId,
            notifications: finalNotifications,
            unreadNotifications,
        });
        addNotifications({
            notifications: finalNotifications,
            unreadNotifications,
            finish: true,
        });
    });
}
exports.softloggedNotificationController = softloggedNotificationController;
exports.default = softloggedNotificationController;
//# sourceMappingURL=softlogged.js.map